import type { ExerciseHistorySet, WorkoutExercise } from "../../shared/schemas.js";

type MeasurementType = WorkoutExercise["measurementType"];
type ExerciseReference = {
  id?: string | undefined;
  exerciseId?: string | null | undefined;
  name: string;
};

export function exerciseHistoryHref(exercise: ExerciseReference): string {
  const query = new URLSearchParams({ name: exercise.name });
  const exerciseId = "exerciseId" in exercise ? exercise.exerciseId : exercise.id;
  if (exerciseId) query.set("exerciseId", exerciseId);
  return `/exercise-history?${query.toString()}`;
}

export function exerciseHistoryApiPath(exerciseId: string | null, name: string, range: "3m" | "1y" | "all"): string {
  const query = new URLSearchParams({ name, range });
  if (exerciseId) query.set("exerciseId", exerciseId);
  return `/api/exercise-history?${query.toString()}`;
}

export function formatHistorySet(set: ExerciseHistorySet, measurementType: MeasurementType): string {
  if (measurementType === "duration") return `${formatNumber(set.seconds)} sec`;
  if (measurementType === "distance") return `${formatNumber(set.distanceM)} m`;
  if (measurementType === "duration_power") return `${formatDuration(set.seconds)} · ${formatNumber(set.averageWatts ?? null)} W`;
  const reps = set.reps ?? "—";
  if (measurementType === "assisted_reps") return `−${formatNumber(set.assistanceKg)} kg × ${reps}`;
  if (measurementType === "bodyweight_reps") {
    const added = set.weightKg && set.weightKg > 0 ? ` + ${formatNumber(set.weightKg)} kg` : "";
    return `BW${added} × ${reps}`;
  }
  return `${formatNumber(set.weightKg)} kg × ${reps}`;
}

export function formatMetricValue(value: number | null, unit: string): string {
  if (value === null) return "—";
  return `${formatNumber(value)} ${unit}`;
}

function formatNumber(value: number | null): string {
  if (value === null) return "—";
  return Number.isInteger(value) ? String(value) : value.toFixed(1);
}

function formatDuration(seconds: number | null): string {
  if (seconds === null) return "—";
  const minutes = seconds / 60;
  return `${Number.isInteger(minutes) ? minutes : minutes.toFixed(1)} min`;
}
